module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "western",
    attrs: {
      "id": "calibre_pb_4"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_vm._v("I must thank my editor, Felicia Sullivan\nfirst. She guided me through the change of style I used in this\nbook, and hopefully I learned enough to make it easier on her when\nshe got the final copy.")]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_vm._v("I could never forget to thank my three beta\nreaders: my friend Sherry F. (maybe someday we can actually meet);\nmy brother Tom for his somewhat slanted view on life which matches\nmy own; and my son Eric, for his youthful view of what could unfold\nand for keeping me straight on all things military - and for\ngetting me into an NG compound so I could climb inside a real\nHumvee!")]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_vm._v("My readers and fans are the best! They have\nsupported and encouraged me to keep going when I was ready to end\nthe series and I thank you for that.")]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_vm._v("And my final thank you is to my publisher,\nMichael Wilson at Permuted Press, for his faith in me.")]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_vm._v("I’ve had many ask about the poems at the\nbeginning of each book. These are all original poems, written by\nme, throughout my life, some going back fifty years. They have all\nbeen written to mark something important in my life, and have\nlittle or no relevance to the story that follows.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12d17152","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue
// module id = 72
// module chunks = 0